export default __webpack_public_path__ + "static/media/ConfigStartup.fb5061bb.svg";